import { QueueAccessType } from 'app/modules/queues/models';
import { AlertStatus } from 'app/modules/alerts/models';
import { ShortCaseResponse } from 'app/modules/cases/responses';
import {
  ActionEventExternalId,
  TxnEventExternalId,
} from 'app/shared/types/eventExternalIds';

export enum AlertType {
  TM = 'TM',
  KYC = 'KYC',
  CHAINALYSIS = 'CHAINALYSIS',
  CAR = 'CAR',
  MANUAL = 'MANUAL',
  WATCHLIST = 'WATCHLIST',
  DARK_WEB = 'DARK_WEB',
  CTR = 'CTR',
  FINCEN_314A = 'FINCEN_314A',
  TRM = 'TRM',
  ONBOARDING = 'ONBOARDING',
  EEL = 'EEL', // External Entity Lookup
}

export enum AlertSubtype {
  CHECK_FRAUD = 'CHECK_FRAUD',
  ADVERSE_MEDIA = 'ADVERSE_MEDIA',
  PEP = 'PEP',
  SANCTIONS = 'SANCTIONS',
}

export enum AlertSource {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
}

export interface AssociatedAlert {
  id: number;
  title: string;
  entity_ids: (number | string)[];
  entity_external_ids: string[];
  instrument_ids: (number | string)[];
  instrument_external_ids: string[];
  description: string;
  disposition: string;
  status: AlertStatus;
  created_at: string | null;
  queue_id: number | null;
  queue_access_type: `${QueueAccessType}`;
}

export interface AssociatedCase {
  id: number;
  title: string | number;
  entity_ids: (number | string)[];
  entity_external_ids: string[];
  // event_ids carries unit21 PKs (paired with event_external_ids below).
  event_ids: (number | string)[];
  event_external_ids: TxnEventExternalId[];
  instrument_ids: (number | string)[];
  instrument_external_ids: string[];
  // action_event_ids carries unit21 PKs (paired with
  // action_event_external_ids below).
  action_event_ids: (number | string)[];
  action_event_external_ids: ActionEventExternalId[];
  queue_id: number | null;
  queue_access_type: `${QueueAccessType}`;
  status?: ShortCaseResponse['status'];
}

export interface AssociatedSAR {
  id: number;
  name: string | number;
  entity_ids: (number | string)[];
  entity_external_ids: string[];
  // event_ids carries unit21 PKs (paired with event_external_ids below).
  event_ids: (number | string)[];
  event_external_ids: TxnEventExternalId[];
  queue_id: number | null;
  queue_access_type: `${QueueAccessType}`;
}
